import { ModuleData, ProductData } from "./handlers";

export const isFlasherValid = (moduleData: ModuleData, productData: ProductData, isModuleValid: (isValid: boolean) => void): boolean => {
    if (!moduleData) return false;
    if (!productData) return false;

    const maxPower = moduleData.maxPower!;
    const maxCurrent = moduleData.maxCurrent!;
    const maxVoltage = moduleData.maxVoltage!;

    const pnominal = safeParse(productData.pnominal);
    const ppCurrent = safeParse(productData.isc);
    const ppVoltage = safeParse(productData.uoc);

    const powerOK = isWithinTolerance(
      maxPower,
      pnominal,
      productData.tolerancepmax
    );

    const currentOK = isWithinTolerance(
      maxCurrent,
      ppCurrent,
      productData.toleranceisc
    );

    const voltageOK = isWithinTolerance(
      maxVoltage,
      ppVoltage,
      productData.tolerancevcc
    );

    const isValid = powerOK && currentOK && voltageOK;

    isModuleValid(isValid);

    return isValid;
  };

  const safeParse = (val: string): number =>
    parseFloat(val.replace(",", ".").replace(/[^\d.-]/g, "")) || 0;

  const isWithinTolerance = (
    measured: number,
    nominal: number,
    tolerance: string
  ): boolean => {
    const percentage = parseFloat(tolerance.replace(/[^\d.]/g, "")) || 0;
    const lowerBound = nominal - (nominal * percentage) / 100;
    const upperBound = nominal + (nominal * percentage) / 100;

    return measured >= lowerBound && measured <= upperBound;
  };
